<template>
    <div class="match-container" :style="{ '--bg-image': `url(${matchData?.league_background || 'https://ldty-1386490300.cos.ap-guangzhou.myqcloud.com/video/20260114/8ae842d3c1f313f3d74b20bb48afa2cb.png'})` }">
        <!-- 背景装饰元素 -->
        <div class="bg-decoration">
            <!-- <div class="basketball-hoop"></div> -->
            <!-- <div class="player-silhouette"></div> -->
        </div>

        <!-- 顶部标题 -->
        <div class="main-title" v-if="matchData?.title">{{ matchData.title }}</div>

        <!-- AI数据标题 -->
        <div class="ai-title">有球之星AI大数据</div>

        <!-- 右上角logo -->
        <div class="top-logo" v-if="matchData?.league_logo">
            <img :src="matchData.league_logo" alt="league logo" class="logo-icon" />
            <img src="@/assets/logo.png" alt="logo" class="logo-icon" />
        </div>

        

        <!-- 主要内容卡片 -->
        <div class="main-card">
            <!-- 队伍信息 -->
            <div class="teams-section">
                <div class="team team-left">
                    <div class="team-logo blue-logo">
                        <img v-if="matchData?.match?.home_logo" :src="matchData.match.home_logo" alt="home team" class="team-logo-img" />
                    </div>
                    <div class="team-name">{{ matchData?.match?.home_name || '主队' }}</div>
                </div>

                <div class="score-section">
                    <div class="match-incidents">
                        <div class="incidents-left">
                            <div class="incident-item">
                                <img src="@/assets/hongpai.png" alt="红牌" class="incident-icon" />
                                <span class="incident-value">{{ getStatData('red_cards').home }}</span>
                            </div>
                            <div class="incident-item">
                                <img src="@/assets/huangpai.png" alt="黄牌" class="incident-icon" />
                                <span class="incident-value">{{ getStatData('yellow_cards').home }}</span>
                            </div>
                            <div class="incident-item">
                                <img src="@/assets/jiaoqiu.png" alt="角球" class="incident-icon" />
                                <span class="incident-value">{{ getStatData('corners').home }}</span>
                            </div>
                        </div>
                        <div class="score">{{ matchData?.match ? `${matchData.match.home_score || 0}-${matchData.match.away_score || 0}` : '0-0' }}</div>
                        <div class="incidents-right">
                            <div class="incident-item">
                                <img src="@/assets/hongpai.png" alt="红牌" class="incident-icon" />
                                <span class="incident-value">{{ getStatData('red_cards').away }}</span>
                            </div>
                            <div class="incident-item">
                                <img src="@/assets/huangpai.png" alt="黄牌" class="incident-icon" />
                                <span class="incident-value">{{ getStatData('yellow_cards').away }}</span>
                            </div>
                            <div class="incident-item">
                                <img src="@/assets/jiaoqiu.png" alt="角球" class="incident-icon" />
                                <span class="incident-value">{{ getStatData('corners').away }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="team team-right">
                    <div class="team-name">{{ matchData?.match?.away_name || '客队' }}</div>
                    <div class="team-logo red-logo">    
                        <img v-if="matchData?.match?.away_logo" :src="matchData.match.away_logo" alt="away team" class="team-logo-img" />
                        <div v-else class="logo-inner">{{ matchData?.match?.away_name || '' }}</div>
                    </div>
                </div>
            </div>

            <!-- 统计数据 -->
            <div class="stats-section">
                <div class="stat-item">
                    <div class="stat-label">射门</div>
                    <div class="stat-bars">
                        <div class="stat-bar blue-bar" :style="{ '--progress-width': getProgressWidth(getStatData('shots_on_target').home + getStatData('shots_off_target').home, getStatData('shots_on_target').away + getStatData('shots_off_target').away).home }"></div>
                        <span class="stat-value stat-value-left">{{ getStatData('shots_on_target').home + getStatData('shots_off_target').home }}</span>
                        <div class="stat-bar red-bar" :style="{ '--progress-width': getProgressWidth(getStatData('shots_on_target').home + getStatData('shots_off_target').home, getStatData('shots_on_target').away + getStatData('shots_off_target').away).away }"></div>
                        <span class="stat-value stat-value-right">{{ getStatData('shots_on_target').away + getStatData('shots_off_target').away }}</span>
                    </div>
                </div>

                <div class="stat-item">
                    <div class="stat-label">射正</div>
                    <div class="stat-bars">
                        <div class="stat-bar blue-bar" :style="{ '--progress-width': getProgressWidth(getStatData('shots_on_target').home, getStatData('shots_on_target').away).home }"></div>
                        <span class="stat-value stat-value-left">{{ getStatData('shots_on_target').home }}</span>
                        <div class="stat-bar red-bar" :style="{ '--progress-width': getProgressWidth(getStatData('shots_on_target').home, getStatData('shots_on_target').away).away }"></div>
                        <span class="stat-value stat-value-right">{{ getStatData('shots_on_target').away }}</span>
                    </div>
                </div>

                <div class="stat-item">
                    <div class="stat-label">进攻</div>
                    <div class="stat-bars">
                        <div class="stat-bar blue-bar" :style="{ '--progress-width': getProgressWidth(getStatData('attacks').home, getStatData('attacks').away).home }"></div>
                        <span class="stat-value stat-value-left">{{ getStatData('attacks').home }}</span>
                        <div class="stat-bar red-bar" :style="{ '--progress-width': getProgressWidth(getStatData('attacks').home, getStatData('attacks').away).away }"></div>
                        <span class="stat-value stat-value-right">{{ getStatData('attacks').away }}</span>
                    </div>
                </div>

                <div class="stat-item">
                    <div class="stat-label">危险进攻</div>
                    <div class="stat-bars">
                        <div class="stat-bar blue-bar" :style="{ '--progress-width': getProgressWidth(getStatData('dangerous_attacks').home, getStatData('dangerous_attacks').away).home }"></div>
                        <span class="stat-value stat-value-left">{{ getStatData('dangerous_attacks').home }}</span>
                        <div class="stat-bar red-bar" :style="{ '--progress-width': getProgressWidth(getStatData('dangerous_attacks').home, getStatData('dangerous_attacks').away).away }"></div>
                        <span class="stat-value stat-value-right">{{ getStatData('dangerous_attacks').away }}</span>
                    </div>
                </div>

                <div class="stat-item">
                    <div class="stat-label">控球率</div>
                    <div class="stat-bars">
                        <div class="stat-bar blue-bar" :style="{ '--progress-width': getProgressWidth(getStatData('possession').home, getStatData('possession').away).home }"></div>
                        <span class="stat-value stat-value-left">{{ getStatData('possession').home }}%</span>
                        <div class="stat-bar red-bar" :style="{ '--progress-width': getProgressWidth(getStatData('possession').home, getStatData('possession').away).away }"></div>
                        <span class="stat-value stat-value-right">{{ getStatData('possession').away }}%</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 背景音乐 -->
        <audio ref="bgmAudio" loop preload="auto" style="display: none;">
            <source src="@/assets/zc.mp3" type="audio/mpeg">
        </audio>

        <!-- 底部机器人装饰 -->
        <div class="robot-decoration">
            <img src="@/assets/jixiangwu.png" alt="robot" class="robot-icon" />
            <!-- <div class="robot">🤖</div> -->
        </div>
    </div>
</template>

<script>
import { useRoute } from 'vue-router'
import { computed, ref, onMounted, onUnmounted } from 'vue'

export default {
    name: 'MatchView',
    setup() {
        const route = useRoute()
        const matchData = ref(null)
        const loading = ref(true)
        const pollTimer = ref(null)

        const matchTypeText = computed(() => {
            const type = route.query.type || route.params.type
            return type
        })

        // 获取比赛详情
        const fetchMatchDetail = async () => {
            try {
                const matchId = route.query.match_id || '1890272' // 默认比赛ID
                const response = await fetch(`https://api.aiyqzx.com/app/v1/other/match_detail?type=${matchTypeText.value}&match_id=${matchId}`)
                const data = await response.json()

                if (data.code === 1) {
                    matchData.value = data.data
                }
            } catch (error) {
                console.error('获取比赛详情失败:', error)
            } finally {
                loading.value = false
            }
        }

        const getWinningTeam = () => {
            if (!matchData.value?.match) return null

            const homeScore = parseInt(matchData.value.match.home_score) || 0
            const awayScore = parseInt(matchData.value.match.away_score) || 0

            if (homeScore > awayScore) return 'left'
            if (awayScore > homeScore) return 'right'
            return null // 平局
        }

        const getStatData = (statName) => {
            if (!matchData.value?.team_statistic) return { home: 0, away: 0 }

            const homeStats = matchData.value.team_statistic.team_A
            const awayStats = matchData.value.team_statistic.team_B

            return {
                home: homeStats[statName] || 0,
                away: awayStats[statName] || 0
            }
        }

        const getProgressWidth = (homeValue, awayValue) => {
            const total = homeValue + awayValue
            if (total === 0) return { home: '0%', away: '0%' }

            const homePercent = (homeValue / total) * 100
            return {
                home: `${homePercent}%`,
                away: `${100 - homePercent}%`
            }
        }

        // 背景音乐播放逻辑
        const bgmAudio = ref(null)
        const bgmPlaying = ref(false)

        const playBackgroundMusic = async () => {
            if (bgmAudio.value && !bgmPlaying.value) {
                try {
                    await bgmAudio.value.play()
                    bgmPlaying.value = true
                    console.log('背景音乐播放成功')
                } catch (error) {
                    console.log('自动播放失败，等待用户交互:', error)

                    // 监听用户交互事件
                    const playOnInteraction = () => {
                        if (bgmAudio.value && !bgmPlaying.value) {
                            bgmAudio.value.play().then(() => {
                                bgmPlaying.value = true
                                console.log('用户交互后音乐播放成功')
                            }).catch(err => console.log('播放失败:', err))
                        }

                        // 移除事件监听器
                        document.removeEventListener('click', playOnInteraction)
                        document.removeEventListener('touchstart', playOnInteraction)
                        document.removeEventListener('keydown', playOnInteraction)
                    }

                    document.addEventListener('click', playOnInteraction)
                    document.addEventListener('touchstart', playOnInteraction)
                    document.addEventListener('keydown', playOnInteraction)
                }
            }
        }

        // 页面加载时获取数据并尝试播放音乐
        onMounted(() => {
            fetchMatchDetail()
            playBackgroundMusic()
            
            // 设置轮询，每秒获取一次比赛数据
            pollTimer.value = setInterval(() => {
                fetchMatchDetail()
            }, 1000)
        })

        // 组件卸载时清理定时器
        onUnmounted(() => {
            if (pollTimer.value) {
                clearInterval(pollTimer.value)
                pollTimer.value = null
            }
        })

        return {
            matchTypeText,
            matchData,
            loading,
            getWinningTeam,
            getStatData,
            getProgressWidth,
            bgmAudio,
            bgmPlaying,
            playBackgroundMusic
        }
    }
}
</script>

<style scoped>
.match-container {
    width: 1920px;
    height: 1080px;
    position: relative;
    overflow: hidden;
    /* background: linear-gradient(135deg, #6B46C1 0%, #3B82F6 50%, #8B5CF6 100%); */
    background: var(--bg-image) no-repeat center center;
    background-size: cover;
    margin: 0 auto;
    font-family: 'Microsoft YaHei', 'PingFang SC', Arial, sans-serif;
}

.bg-decoration {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
}

.basketball-hoop {
    position: absolute;
    left: 50px;
    top: 200px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(255, 107, 107, 0.3) 0%, transparent 70%);
    border-radius: 50%;
    transform: rotate(-20deg);
}

.player-silhouette {
    position: absolute;
    right: 100px;
    top: 150px;
    width: 300px;
    height: 400px;
    background: linear-gradient(135deg, rgba(255, 107, 107, 0.2) 0%, rgba(255, 159, 64, 0.2) 100%);
    border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
    transform: rotate(15deg);
}

.main-title {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 560px);
    font-size: 48px;
    line-height: 1.35;
    text-align: center;
    white-space: nowrap;
    font-weight: bold;
    color: white;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    z-index: 2;
}

.ai-title {
    position: absolute;
    top: 165px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
    font-weight: 600;
    color: white;
    background: #f37739;
    padding: 12px 160px;
    clip-path: polygon(10% 0%, 0% 100%, 100% 100%, 90% 0%);
    z-index: 2;
}

.top-logo {
    position: absolute;
    top: 40px;
    right: 60px;
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 2;
}

.logo-icon {
    width: 80px;
    height: 80px;
    object-fit: contain;
    margin-left: 30px;
}

.logo-text {
    font-size: 24px;
    font-weight: bold;
    color: white;
}

.main-card {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1500px;
    background: white;
    border-radius: 20px;
    padding: 60px 80px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    z-index: 1;
    margin-top: 30px;
}

.teams-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
    width: 90%;
    margin: 0 auto;
}

.team {
    position: relative;
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    gap: 20px;
    flex: 1;
}

.team-logo {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    font-weight: bold;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.blue-logo {
    background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
    color: white;
}

.red-logo {
    background: linear-gradient(135deg, #f37739 0%, #f37739 100%);
    color: white;
    font-size: 20px;
    text-align: center;
    padding: 10px;
}

.logo-inner {
    display: flex;
    align-items: center;
    justify-content: center;
}

.team-logo-img {
    width: 90px;
    height: 90px;
    border-radius: 12px;
    object-fit: cover;
}


.win-badge {
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.win-icon {
    width: 50px;
    height: 50px;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
}

.team-right .team-name {
    text-align: right;
}

.team-name {
    font-size: 32px;
    font-weight: bold;
    color: #1F2937;
    width: 5em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.score-section {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px;

}

.match-incidents {
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    gap: 15px;
}

.incidents-left,
.incidents-right {
    display: flex;
    gap: 12px;
    align-items: center;
}

.incidents-right {
    flex-direction: row-reverse;
}

.incident-item {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-direction: column;
    margin: 0px 10px;
}

.incident-icon {
    width: 30px;
    height: 30px;
    object-fit: contain;
}

.incident-value {
    font-size: 18px;
    font-weight: bold;
    color: #1F2937;
}


.team-right {
    justify-content: flex-end;
}

.score {
    font-size: 62px;
    font-weight: bold;
    color: #1F2937;
    letter-spacing: 10px;
    width: 260px;
    text-align: center;
    /* margin: 0 30rpx; */
}

.stats-section {
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 70%;
    margin: 0 auto;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 30px;
    flex-direction: column;
    justify-content: center;
}

.stat-label {
    width: 120px;
    font-size: 24px;
    font-weight: 600;
    color: #374151;
    text-align: center;
}

.stat-bars {
    display: flex;
    gap: 20px;
    width: 100%;
    height: 20px;
    position: relative;
    align-items: center;
}

.stat-bar {
    flex: 1;
    height: 100%;
    border-radius: 25px;
    overflow: hidden;
    position: relative;
    background-color: #E5E7EB;
}

.stat-bar::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: var(--progress-width, 0%);
    border-radius: 25px;
    transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 0;
    animation: progress-fill 1.5s ease-in-out infinite;
}

.stat-bar::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: var(--progress-width, 0%);
    border-radius: 25px;
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(255, 255, 255, 0.4) 50%,
            transparent 100%);
    animation: shimmer 2s ease-in-out infinite;
    z-index: 1;
    transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.blue-bar::before {
    background: linear-gradient(90deg, #3B82F6 0%, #2563EB 100%);
}

.blue-bar::after {
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(255, 255, 255, 0.4) 50%,
            transparent 100%);
}

.red-bar::before {
    background: linear-gradient(90deg, #F37739 0%, #F37739 100%);
    left: auto;
    right: 0;
    animation: progress-fill-red 1.5s ease-in-out infinite;
}

.red-bar::after {
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(255, 255, 255, 0.4) 50%,
            transparent 100%);
    left: auto;
    right: 0;
    animation: shimmer-red 2s ease-in-out infinite;
}

.stat-value {
    position: absolute;
    font-size: 22px;
    font-weight: bold;
    color: #1F2937;
    z-index: 2;
    white-space: nowrap;
    width: 80px;
    text-align: center;
}

.stat-value-left {
    left: -80px;
}

.stat-value-right {
    right: -80px;
}

.robot-decoration {
    position: absolute;
    bottom: -40px;
    left: -100px;
    z-index: 2;
    animation: float 3s ease-in-out infinite;
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0px) rotate(-2deg);
    }

    25% {
        transform: translateY(-5px) rotate(1deg);
    }

    50% {
        transform: translateY(-10px) rotate(2deg);
    }

    75% {
        transform: translateY(-5px) rotate(-1deg);
    }
}

@keyframes progress-fill {
    0% {
        filter: brightness(1) saturate(1);
        box-shadow: 0 0 0 rgba(59, 130, 246, 0);
    }

    50% {
        filter: brightness(1.2) saturate(1.3);
        box-shadow: 0 0 20px rgba(59, 130, 246, 0.6), 0 0 40px rgba(59, 130, 246, 0.4);
    }

    100% {
        filter: brightness(1) saturate(1);
        box-shadow: 0 0 0 rgba(59, 130, 246, 0);
    }
}

@keyframes shimmer {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        transform: translateX(100%);
        opacity: 0;
    }
}

@keyframes progress-fill-red {
    0% {
        filter: brightness(1) saturate(1);
        box-shadow: 0 0 0 rgba(243, 119, 57, 0);
    }

    50% {
        filter: brightness(1.2) saturate(1.3);
        box-shadow: 0 0 20px rgba(243, 119, 57, 0.6), 0 0 40px rgba(243, 119, 57, 0.4);
    }

    100% {
        filter: brightness(1) saturate(1);
        box-shadow: 0 0 0 rgba(243, 119, 57, 0);
    }
}

@keyframes shimmer-red {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        transform: translateX(-100%);
        opacity: 0;
    }
}

.robot {
    font-size: 80px;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}
</style>
